var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { createContext, useMemo } from "react";
/**
 * Authentication context provider component.
 * Provides the app with session information.
 * Not to be used directly as it does not have access to state.
 *
 * @copyright 2022 Noom, Inc.
 * @author nikola
 */
export const Context = createContext(null);
export function AuthContext(_a) {
    var { children, useCSAuth = true, csClientId, csServerUrl, authState, inProgress, setInProgress, error, setError } = _a, props = __rest(_a, ["children", "useCSAuth", "csClientId", "csServerUrl", "authState", "inProgress", "setInProgress", "error", "setError"]);
    const csProps = useCSAuth
        ? { useCSAuth, csClientId, csServerUrl }
        : { useCSAuth };
    const contextValue = useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign({}, authState), props), csProps), { inProgress,
        setInProgress,
        error,
        setError })), [authState, props, csProps, inProgress, setInProgress, error, setError]);
    return React.createElement(Context.Provider, { value: contextValue }, children);
}
export default AuthContext;
//# sourceMappingURL=AuthContextProvider.js.map